module.exports = __webpack_public_path__ + "img/skitime2.7c598178.jpg";